export const FEAT_SPELLCASTING = [
  { name: "Kitsune Spell Familiarity", showSlotless: false, knownSpells: ["Daze", "Forbidding Ward", "Ghost Sound"], preparePBSpells: true },
  { name: "Kitsune Spell Expertise", showSlotless: false, knownSpells: ["Confusion", "Death Ward", "Illusory Scene"], preparePBSpells: true },
  { name: "Kitsune Spell Mysteries", showSlotless: false, knownSpells: ["Bane", "Illusory Object", "Sanctuary"], preparePBSpells: true },
  { name: "Nagaji Spell Familiarity", showSlotless: false, knownSpells: ["Daze", "Detect Magic", "Mage Hand"], preparePBSpells: true },
  { name: "Nagaji Spell Expertise", showSlotless: false, knownSpells: ["Blink", "Control Water", "Subconscious Suggestion"], preparePBSpells: true },
  { name: "Nagaji Spell Mysteries", showSlotless: false, knownSpells: ["Charm", "Fleet Step", "Heal"], preparePBSpells: true },
  { name: "Rat Magic", showSlotless: false, knownSpells: [], preparePBSpells: true },
];

const REMASTER_NAMES = [
  { pbName: "Animate Dead", foundryName: "Summon Undead" },
  { pbName: "Augment Summoning", foundryName: "Fortify Summoning" },
  { pbName: "Baleful Polymorph", foundryName: "Cursed Metamorphosis" },
  { pbName: "Barkskin", foundryName: "Oaken Resilience" },
  { pbName: "Bind Soul", foundryName: "Seize Soul" },
  { pbName: "Blind Ambition", foundryName: "Ignite Ambition" },
  { pbName: "Blink", foundryName: "Flicker" },
  { pbName: "Burning Hands", foundryName: "Breathe Fire" },
  { pbName: "Calm Emotions", foundryName: "Calm" },
  { pbName: "Charming Words", foundryName: "Charming Push" },
  { pbName: "Chill Touch", foundryName: "Void Warp" },
  { pbName: "Cloudkill", foundryName: "Toxic Cloud" },
  { pbName: "Color Spray", foundryName: "Dizzying Colors" },
  { pbName: "Commune with Nature", foundryName: "Commune" },
  { pbName: "Comprehend Language", foundryName: "Translate" },
  { pbName: "Continual Flame", foundryName: "Everlight" },
  { pbName: "Crushing Despair", foundryName: "Wave of Despair" },
  { pbName: "Dancing Lights", foundryName: "Light" },
  { pbName: "Dimension Door", foundryName: "Translocate" },
  { pbName: "Dimensional Anchor", foundryName: "Planar Seal" },
  { pbName: "Dimensional Lock", foundryName: "Planar Tether" },
  { pbName: "Discern Location", foundryName: "Pinpoint" },
  { pbName: "Disrupt Undead", foundryName: "Vitality Lash" },
  { pbName: "Disrupting Weapons", foundryName: "Infuse Vitality" },
  { pbName: "Endure Elements", foundryName: "Environmental Endurance" },
  { pbName: "Entangle", foundryName: "Entangling Flora" },
  { pbName: "False Life", foundryName: "False Vitality" },
  { pbName: "Feather Fall", foundryName: "Gentle Landing" },
  { pbName: "Feeblemind", foundryName: "Never Mind" },
  { pbName: "Finger of Death", foundryName: "Execute" },
  { pbName: "Flaming Sphere", foundryName: "Floating Flame" },
  { pbName: "Flesh To Stone", foundryName: "Petrify" },
  { pbName: "Freedom of Movement", foundryName: "Unfettered Movement" },
  { pbName: "Gaseous Form", foundryName: "Vapor Form" },
  { pbName: "Gentle Repose", foundryName: "Peaceful Rest" },
  { pbName: "Glibness", foundryName: "Honeyed Words" },
  { pbName: "Glitterdust", foundryName: "Revealing Light" },
  { pbName: "Globe of Invulnerability", foundryName: "Dispelling Globe" },
  { pbName: "Hallucinatory Terrain", foundryName: "Mirage" },
  { pbName: "Hideous Laughter", foundryName: "Laughing Fit" },
  { pbName: "Horrid Wilting", foundryName: "Desiccate" },
  { pbName: "Hypnotic Pattern", foundryName: "Hypnotize" },
  { pbName: "Inspire Competence", foundryName: "Uplifting Overture" },
  { pbName: "Inspire Courage", foundryName: "Courageous Anthem" },
  { pbName: "Inspire Defense", foundryName: "Rallying Anthem" },
  { pbName: "Inspire Heroics", foundryName: "Fortissimo Composition" },
  { pbName: "Know Direction", foundryName: "Know the Way" },
  { pbName: "Legend Lore", foundryName: "Collective Memories" },
  { pbName: "Longstrider", foundryName: "Tailwind" },
  { pbName: "Mage Armor", foundryName: "Mystic Armor" },
  { pbName: "Mage Hand", foundryName: "Telekinetic Hand" },
  { pbName: "Magic Aura", foundryName: "Disguise Magic" },
  { pbName: "Magic Fang", foundryName: "Runic Body" },
  { pbName: "Magic Missile", foundryName: "Force Barrage" },
  { pbName: "Magic Mouth", foundryName: "Embed Message" },
  { pbName: "Magic Weapon", foundryName: "Runic Weapon" },
  { pbName: "Magnificent Mansion", foundryName: "Planar Palace" },
  { pbName: "Maze", foundryName: "Quandary" },
  { pbName: "Meld into Stone", foundryName: "One with Stone" },
  { pbName: "Meteor Swarm", foundryName: "Falling Stars" },
  { pbName: "Mind Blank", foundryName: "Hidden Mind" },
  { pbName: "Misdirection", foundryName: "Disguise Magic" },
  { pbName: "Modify Memory", foundryName: "Rewrite Memory" },
  { pbName: "Neutralize Poison", foundryName: "Cleanse Affliction" },
  { pbName: "Nondetection", foundryName: "Veil of Privacy" },
  { pbName: "Obscuring Mist", foundryName: "Mist" },
  { pbName: "Pass Without Trace", foundryName: "Vanishing Tracks" },
  { pbName: "Passwall", foundryName: "Magic Passage" },
  { pbName: "Phantom Mount", foundryName: "Marvelous Mount" },
  { pbName: "Planar Binding", foundryName: "Planar Servitor" },
  { pbName: "Plane Shift", foundryName: "Interplanar Teleport" },
  { pbName: "Positive Luminance", foundryName: "Vital Luminance" },
  { pbName: "Private Sanctum", foundryName: "Peaceful Bubble" },
  { pbName: "Prying Eye", foundryName: "Scouting Eye" },
  { pbName: "Pulse of The City", foundryName: "Pulse of Civilization" },
  { pbName: "Purify Food And Drink", foundryName: "Cleanse Cuisine" },
  { pbName: "Ray of Enfeeblement", foundryName: "Enfeeble" },
  { pbName: "Remove Curse", foundryName: "Cleanse Affliction" },
  { pbName: "Remove Disease", foundryName: "Cleanse Affliction" },
  { pbName: "Remove Fear", foundryName: "Clear Mind" },
  { pbName: "Remove Paralysis", foundryName: "Sure Footing" },
  { pbName: "Restore Senses", foundryName: "Sound Body" },
  { pbName: "Scorching Ray", foundryName: "Blazing Bolt" },
  { pbName: "Searing Light", foundryName: "Holy Light" },
  { pbName: "See Invisibility", foundryName: "See the Unseen" },
  { pbName: "Shadow Walk", foundryName: "Umbral Journey" },
  { pbName: "Shapechange", foundryName: "Metamorphosis" },
  { pbName: "Shield Other", foundryName: "Share Life" },
  { pbName: "Sound Burst", foundryName: "Noise Blast" },
  { pbName: "Spectral Hand", foundryName: "Ghostly Carrier" },
  { pbName: "Spider Climb", foundryName: "Gecko Grip" },
  { pbName: "Splash of Art", foundryName: "Creative Splash" },
  { pbName: "Stone Tell", foundryName: "Speak with Stones" },
  { pbName: "Stoneskin", foundryName: "Mountain Resilience" },
  { pbName: "Tanglefoot", foundryName: "Tangle Vine" },
  { pbName: "Time Stop", foundryName: "Freeze Time" },
  { pbName: "Tongues", foundryName: "Truespeech" },
  { pbName: "Touch of Idiocy", foundryName: "Stupefy" },
  { pbName: "Tree Shape", foundryName: "One with Plants" },
  { pbName: "Tree Stride", foundryName: "Nature's Pathway" },
  { pbName: "Trueseeing", foundryName: "Truesight" },
  { pbName: "True Strike", foundryName: "Sure Strike" },
  { pbName: "Unseen Servant", foundryName: "Phantasmal Minion" },
  { pbName: "Vampiric Touch", foundryName: "Vampiric Feast" },
  { pbName: "Veil", foundryName: "Illusory Disguise" },
  { pbName: "Vigilant Eye", foundryName: "Rune of Observation" },
  { pbName: "Wail of the Banshee", foundryName: "Wails of the Damned" },
  { pbName: "Wind Walk", foundryName: "Migration" },
  { pbName: "Zone of Truth", foundryName: "Ring of Truth" },
];

export function spellRename(spellName) {
  if (foundry.utils.isNewerVersion(game.version, "5.9.0") && game.modules.get("pf2e-legacy-content")?.active) return spellName;
  const remasterName = REMASTER_NAMES.find((remaster) => remaster.pbName === spellName);
  if (remasterName) {
    return remasterName.foundryName;
  }
  return spellName;
}
